import React                      from "react";
import { StyleSheet, View, Text } from "react-native";
import { Screen }                 from "~/components/layouts/Screen/index.web";
import { Paragraph }              from "~/components/text/Paragraph";

export const DashboardScreen = ({ style = {} }) => {
  return (
    <Screen fluid>
      <View style={[styles.container]}>
        <Text>Dashboard</Text>
      </View>
    </Screen>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    display: "flex",
  },
});
